module.exports = __webpack_public_path__ + "img/ngc.73653f0f.svg";